import { Auxiliares } from "../../types/TabelasAuxiliares/Auxiliares";
import { AuxiliaresParams } from "../../types/TabelasAuxiliares/AuxiliaresParams";
import api from "../../utils/api";
import { NATIONALITY_URL } from "../../utils/endpoints";

export async function getNationality(params: AuxiliaresParams) {
  try {
    let qs = "";
    qs += `OnlyActive=${
      params?.OnlyActive !== undefined ? params.OnlyActive : true
    }`;
    qs += params?.ParentId ? `&ParentId=${params.ParentId}` : "";
    const response = await api.get(`${NATIONALITY_URL}?${qs}`);
    const data: Auxiliares[] = response.data.map((option: Auxiliares) => ({
      id: option.id,
      name: option.name,
      code: option.code,
      isActive: option.isActive,
    }));
    return data;
  } catch (error) {
    throw error;
  }
}
